import {
  Box,
  Flex,
  Spinner,
  useBreakpointValue,
  useToast
} from "@chakra-ui/react";
import { format, utcToZonedTime } from "date-fns-tz";
import { useState, useEffect } from "react";
import ContentBase from "../../components/ContentBase";

import { Header } from "../../components/Header";
import MainBase from "../../components/MainBase";
import { MyCreditsHeader } from "../../components/MyCredits/Header";
import { MyCreditsTable } from "../../components/MyCredits/Table";
import { Sidebar } from "../../components/Sidebar";
import { api } from "../../services/api";

type CreditProps = {
  id: string;
  amount: string;
  expiration_date: string;
  user_id: string;
  balance: string;
  purchase_id: string;
  created_at: string;
  createdAtFormatted?: string;
  expirationDateFormatted?: string;
}

export function MyCredits() {
  const [balance, setBalance] = useState<number>(0)
  const [credits, setCredits] = useState<CreditProps[]>([]);
  const [isLoading, setLoading] = useState<boolean>(false);

  const toast = useToast();

  useEffect(() => {
    try {
      setLoading(true)
      api.get<CreditProps[]>("/credits/available").then(response => {
        const { data } = response;
        let balance = 0

        const creditsData = data.map(credit => {
          balance += Number(credit.balance)
          return {
            ...credit,
            expirationDateFormatted: format(
              utcToZonedTime(credit.expiration_date, 'America/Sao_Paulo'),
              'dd/MM/yyyy'
            ),
            createdAtFormatted: format(
              utcToZonedTime(credit.created_at, 'America/Sao_Paulo'),
              'dd/MM/yyyy'
            ),
          }
        })

        setBalance(balance);
        setCredits(creditsData);
        setLoading(false)
      })
    } catch (err) {
      toast({
        title: "Opa...",
        description: "Ocorreu uma instabilidade. Por favor tente novamente mais tarde.",
        status: "error",
        duration: 3000, // 3 seconds,
        isClosable: true,
        position: "top-right",
      })

      setLoading(false)
    }
  }, [toast])

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  })

  return (
    <Flex direction="column" h="100vh">
      { !isWideVersion && <Header /> }

      <ContentBase>
        <Sidebar />

        <MainBase
          mainTitle="Meus créditos"
          isLoading={isLoading}
        >
          <Box
            h={["", "86vh"]}
            overflow="auto"
            paddingRight="1"
            css={{
              '&::-webkit-scrollbar': {
                width: '4px',
              },
              '&::-webkit-scrollbar-track': {
                width: '6px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: "var(--chakra-colors-gray-400)",
                borderRadius: '25px',
              },
            }}
          >
            { isLoading ?
              <Flex justify="center">
                <Spinner color="blue.900" size="xl" />
              </Flex>
            :
              <>
                <MyCreditsHeader balance={balance} />
                <MyCreditsTable credits={credits} />
              </>
            }
          </Box>
        </MainBase>
      </ContentBase>
    </Flex>
  )
}
